import ApiUrl from "./ApiUrl";

const CoursesUrl = ApiUrl + "courses/";

//courses/register

export const CreateCourseService = (data) => {
   // lista de todos los usuarios
   // endDate es el total de horas
   const service = `${CoursesUrl}register`;
   const options = {
      method: "POST",
      //mode: "no-cors",
      body: data,
      headers: {
         "Content-Type": "multipart/form-data",
      },
   };
   delete options.headers["Content-Type"];
   return fetch(service, options);
};
export const DeleteCourse = (id) => {
   const service = `${CoursesUrl}delete`;
   const data = {idCourse: id, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const ListByEssential = () => {
   // lista de todos los usuarios
   const service = `${CoursesUrl}listByEssential`;
   // const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service);
};
export const ListByPrime = () => {
   // lista de todos los usuarios
   const service = `${CoursesUrl}listByPrime`;
   // const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service);
};
export const ListByEmblem = () => {
   // lista de todos los usuarios
   const service = `${CoursesUrl}listByEmblem`;
   // const data = {...dat, token: localStorage.getItem("domecq_token")};
   return fetch(service);
};
export const ListByCourseType = (id) => {
   // lista de todos los usuarios
   const service = `${CoursesUrl}listByCourseType`;
   const data = {idCourseType: id, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const SingleCourseInfo = (id) => {
   // lista de todos los usuarios
   const service = `${CoursesUrl}single_course`;
   const data = {idCourse: id, token: localStorage.getItem("domecq_token")};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
// recursos
export const ResourceCourseService = (id) => {
   // lista de todos los usuarios
   const service = `${ApiUrl}resources/listByCourse`;
   const data = {idCourse: id};
   return fetch(service, {
      method: "POST",
      body: JSON.stringify({...data}),
      headers: {
         "Content-Type": "application/json",
      },
   });
};
export const NextCoursesservice = () => {
   //domecqapi.trebolbit.com/api/courses/listOfDates
   const service = `${ApiUrl}courses/listOfDates`;
   // const data = {idCourse: id};
   return fetch(service);
};
